const prefix = 'MEMO:'

export const MEMO_RECEIVED = prefix + 'MEMO_RECEIVED'

export const SET_RECEIVED_UNAPPROVED_MEMOS = prefix + 'SET_RECEIVED_UNAPPROVED_MEMOS'

export const APPROVE_OR_REJECT_NOTIFY_MEMO = prefix + 'APPROVE_OR_REJECT_NOTIFY_MEMO'

export const SET_APPROVED_REJECTED_MEMOS = prefix + 'SET_APPROVED_REJECTED_MEMOS'